import { useState, useEffect } from 'react';
import { Card, Text, Group, Avatar } from '@mantine/core';
import { Link } from 'react-router-dom';
import classes from './TrendingCards.module.css';
import { getTrendingVideos } from '../../services/api';

interface TrendingVideo {
    id: number;
    videoTitle: string;
    channel: string;
    channelId: string;
    channelAvatar: string;
    views: string;
    timeAgo: string;
    urlVideo: string;
}

function decodeHtmlEntities(text: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
}

export function TrendingCards() {
    const [trendingData, setTrendingData] = useState<TrendingVideo[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        async function fetchTrendingVideos() {
            try {
                const response = await getTrendingVideos();
                if (Array.isArray(response.data)) {
                    setTrendingData(response.data);
                } else {
                    setError('Unexpected response format');
                }
            } catch (err) {
                setError('Failed to fetch trending videos');
            }
        }

        fetchTrendingVideos();
    }, []);

    if (error) {
        return <div className={classes.error}>{error}</div>;
    }

    return (
        <div className={classes.container}>
            <div className={classes.grid}>
                {trendingData.map((video, index) => (
                    <Card key={video.id} p={0} radius="md" className={classes.card}>
                        <div className={classes.videoWrapper}>
                            <iframe
                                width="100%"
                                height="100%"
                                src={`https://www.youtube.com/embed/${video.urlVideo}`}
                                title={video.videoTitle}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                className={classes.iframe}
                            />
                            <div className={classes.views}>
                                {parseInt(video.views.replace(/\D/g, ''), 10).toLocaleString('it-IT')} views
                            </div>
                        </div>
                        <div className={classes.videoInfo}>
                            <Text lineClamp={2} size="sm" fw={500} className={classes.videoTitle}>
                                {decodeHtmlEntities(video.videoTitle)}
                            </Text>
                            <div className={classes.channelInfo}>
                                <div className={classes.rankBadge}>#{index + 1}</div>
                                <Link to={`/channel/${video.channelId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <Group gap={6}>
                                        <Avatar
                                            src={video.channelAvatar}
                                            size="sm"
                                            radius="xl"
                                        />
                                        <div>
                                            <Text size="sm">{video.channel}</Text>
                                            <Group gap={4}>
                                                <Text size="xs" c="dimmed">{video.timeAgo}</Text>
                                            </Group>
                                        </div>
                                    </Group>
                                </Link>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
}
